// split-test: iscroll_modal

import {
  triggerCustomEvent,
  getCurrentPageParam,
} from 'lib/helpers';
import { getAjaxModal } from 'lib/ajax-helpers';
import { fetchState, setState } from 'lib/state-helpers';
import { getContextPositionByHref } from 'lib/show-modal-helpers';
import Cookies from 'js-cookie';
import events from 'lib/events';

const fetchReferringPath = () => document.body.getAttribute('data-referring-path');

const hasResourceShowModal = () => {
  if (document.querySelector('#resource-show-modal-view')) {
    return true;
  }

  return false;
};

const saveSearchPageNum = () => {
  const pageNum = getCurrentPageParam();

  if (pageNum) Cookies.set('temp-search-page-num', pageNum);
};

const openModalFromHistory = (modalData) => {
  triggerCustomEvent(events.show_page.modal.update_resource_navigation_context, {
    newCurrentPath: modalData.path,
  });

  saveSearchPageNum();

  triggerCustomEvent(events.show_page.modal.reload_modal_view);

  const navContext = modalData.navContext || fetchState('resources-nav-context');
  setState('resources-nav-context', navContext);

  window.history.replaceState({
    modalData: {
      id: 'resource-show-modal-view',
      title: modalData.title,
      path: modalData.path,
      contextPath: fetchReferringPath(),
      navContext,
    },
  }, modalData.title, modalData.path);

  getAjaxModal(modalData.path, null, null, { history_click: true });
};

const openModalInPreviousContext = (modalData) => {
  window.localStorage.setItem('open_modal_show_on_page_load', JSON.stringify(modalData));

  window.history.replaceState({
    modalData: {
      id: 'resource-show-modal-view',
      title: modalData.title,
      path: modalData.path,
      contextPath: modalData.contextPath,
    },
  }, modalData.title, modalData.contextPath);

  window.history.go(modalData.contextPath);
};

const restoreModalView = (modalData, referringPath) => {
  if (referringPath !== modalData.contextPath) {
    openModalInPreviousContext(modalData);
  } else {
    openModalFromHistory(modalData);
  }
};

const historyState = (event, referringPath) => {
  if (event.state.modalData) {
    restoreModalView(event.state.modalData, referringPath);
  } else if (hasResourceShowModal()) {
    triggerCustomEvent(events.show_page.modal.history_close_modal_view);
  }
};

const addModalHistoryAttrToBody = () => {
  document.querySelector('body').dataset.modalViewFromHistory = true;
};

const popstateFromModalHistory = (state) => {
  if (!state) return false;
  if (state.turbolinks) return false;

  return Object.entries(state).length > 0;
};

const buildResourceNavigationContext = (event) => {
  const { targetResourcePath } = event.detail;
  const gridContainer = event.detail.targetResourceGroup;
  const gridItems = [...gridContainer.querySelectorAll('.ez-resource-thumb__link')];
  const resourcesNavContext = {};

  gridItems.forEach((item, index) => {
    resourcesNavContext[index] = {
      id: item.parentNode.dataset.itemId,
      href: item.getAttribute('href'),
      previewsSrcs: item.dataset.previewsSrcs,
    };
  });

  resourcesNavContext.currentPosition = getContextPositionByHref(resourcesNavContext, targetResourcePath);

  setState('resources-nav-context', resourcesNavContext);
};

if (window.localStorage.getItem('open_modal_show_on_page_load')) {
  openModalFromHistory(JSON.parse(window.localStorage.getItem('open_modal_show_on_page_load')));

  window.localStorage.removeItem('open_modal_show_on_page_load');
}

window.addEventListener(events.show_page.modal.build_resource_navigation_context, buildResourceNavigationContext);

window.addEventListener('popstate', (event) => {
  if (popstateFromModalHistory(event)) {
    addModalHistoryAttrToBody();
    historyState(event, fetchReferringPath());
  } else if (hasResourceShowModal()) {
    triggerCustomEvent(events.show_page.modal.history_close_modal_view, { updateState: false });
  } else {
    window.history.go(document.location);
  }
});
